import { Lock } from 'lucide-react';

export interface ReadOnlyLockBannerProps {
  canEditThisTimesheet: boolean;
}

/**
 * View-only notice shown when the user can view but not edit the timesheet
 * being displayed (Edit access level None/Own while viewing another employee).
 */
export function ReadOnlyLockBanner({ canEditThisTimesheet }: ReadOnlyLockBannerProps) {
  if (canEditThisTimesheet) return null;

  return (
    <div className="pb-2">
      <div className="flex items-start gap-2 border border-amber-400 bg-amber-50 dark:bg-amber-950/20 rounded px-3 py-2">
        <Lock className="h-4 w-4 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
        <span className="text-amber-800 dark:text-amber-200 leading-tight" style={{ fontSize: '12px' }}>
          You don't have permission to edit this timesheet. It is shown in view-only mode.
        </span>
      </div>
    </div>
  );
}
